export const shortenAddress = (address) => address
    ? `${address.substring(0, 7)}...${address.substring(address.length - 5)}`
    : null;
//# sourceMappingURL=wallet.js.map